const handleItemClick = (e, line_item) => {
  const afterClick = new Event("algoliaShopify.autocomplete.hitClickAction");
  document.dispatchEvent(afterClick);

  if (algoliaShopify.config.analytics_enabled) {
    const clickData = {
      index: line_item.__autocomplete_indexName,
      eventName: "Added to cart",
      queryID: line_item.__autocomplete_queryID,
      objectIDs: [line_item.objectID],
    };
    algoliaShopify.saveForConversionTracking(clickData);
  }

  const customerCustomAction = algoliaShopify.hooks.triggerHooks(
    "afterAutocompleteProductClickAction",
    undefined,
    line_item
  );

  if (typeof customerCustomAction === "function") {
    customerCustomAction();
  }
};
const handleQuickViewClick = (e, hit) => {
  e.preventDefault();
  fetch(e.target.dataset.productUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          let productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
              productElement.querySelector("nav.breadcrumbs").remove()

              productElement = preventDuplicatedIDs(productElement);
              productElement = removeDOMElements(productElement);
              setInnerHTML( document.querySelector('.ca-qv-product-content'), productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          removeGalleryListSemantic();
          preventVariantURLSwitching();
          removingReviewTab();

          document.querySelector('.custom-ais-quick-view-wrapper')?.classList.add("active");
          document.querySelector('body')?.classList.add("overflow-hidden")
        })

  function preventDuplicatedIDs(productElement) {
    const sectionId = productElement.dataset.section;
    productElement.innerHTML = productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
    productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
      variantSelect.dataset.originalSection = sectionId;
    });
    return productElement;
  }
  function removeDOMElements(productElement) {
    const pickupAvailability = productElement.querySelector('pickup-availability');
    if (pickupAvailability) pickupAvailability.remove();

    const productModal = productElement.querySelector('product-modal');
    if (productModal) productModal.remove();

    return productElement;
  }
  function setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
  function removeGalleryListSemantic() {
    const galleryList = document.querySelector('.ca-qv-product-content [id^="Slider-Gallery"]');
    if (!galleryList) return;

    galleryList.setAttribute('role', 'presentation');
    galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
  }
  function preventVariantURLSwitching() {
    document.querySelector('.ca-qv-product-content variant-radios, .ca-qv-product-content variant-selects').setAttribute('data-update-url', 'false');
  }
  function removingReviewTab() {
    const reviewTab = document.querySelector('#pro-accordion .accordion-box:not([data-title])')
    if(reviewTab && reviewTab?.querySelector('a[href="#review-block"]')) reviewTab.remove()
  }

}

const handleQuickViewClose = (event) => {
  document.querySelector('.custom-ais-quick-view-wrapper')?.classList.remove("active");
  document.querySelector('body')?.classList.remove("overflow-hidden")
  
}

const handleQuickViewOverlay = (event) => {
  if (event.target === document.querySelector('.custom-ais-quick-view-wrapper')) {
    document.querySelector('.custom-ais-quick-view-wrapper')?.classList.remove("active");
    document.querySelector('body')?.classList.remove("overflow-hidden")
  }
}

const consult_tag_translation = (tag) => {
  let foundTag = product_tags_translations.find((element) => element.includes(`${tag}`));
  if (foundTag) {
    let en = foundTag.split(':')[1];
    let fr = foundTag.includes('_') ? foundTag.split('_')[1].split(':')[0] : foundTag.split(':')[0];
    
    if(document.body.dataset.locale == "en") {
      return en
    }else {
      return fr
    }
  }
  return ''

}

document.addEventListener('algolia.hooks.initialize', function() {

  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    options.container = window.innerWidth < 990 ? document.querySelector("#search-autocomplete-mobile") : options.container ;
    options.detachedMediaQuery = "(max-width: 1px)";
    return options;
  });

  /* Search Page widget */
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          Show filters
        </div>
        <ais-filters-drawer>
          <div id="aisSidebarFacets" class="ais-sidebar-facets">
            <div id="aisSidebarOverlay" class="ais-sidebar-overlay"> </div>
            <div class="ais-facets">
              <div class="ais-filters__header">
                <div class="ais-filters__header-inner">
                  <p class="ais-filters__heading ">${algoliaShopify.translations.sortBy}</p>
                  <span tabindex="0" class="ais-filters__close" id="aisFiltersClose">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg>
                  </span>
                </div>
              </div>
              <div class="ais-current-refined-values-container"></div>
              ${data.facets.map(
                facet =>
                  html`
                    <div
                      class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                    >
                      <label
                        for="${facet.escapedName}"
                        class="ais-range-slider--header ais-facet--header ais-header"
                        >${facet.title}</label
                      >
                      <input
                        class="ais-dropdown-checkbox"
                        type="checkbox"
                        id="${facet.escapedName}"
                        name="dropdown"
                      />
                      <div
                        class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                      ></div>
                    </div>
                  `
              )}

              <div class="ais-clear-refinements-container"></div>
            </div>
          </div>
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display hidden">

              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div id="aisOpenSidebarFilters" class="ais-open-sidebar-filters">
              ${algoliaShopify.translations.sortBy}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
      <div class="custom-ais-quick-view-wrapper" onClick="${(event) => handleQuickViewOverlay(event)}">
          <div class="custom-ais-quick-view-container">
            <button type="button" class="ca-qv-close" onClick="${(event) => handleQuickViewClose(event)}">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                    <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
                </svg>
            </button>
            <div class="ca-qv-product-content"></div>
          </div>
        </div>
    `;
  });
  
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
    let available_ = true;
    return html`
      <div
        class=" ais-product"

        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
      >
        <div class="ais-hit--container-picture">
          <a
            data-algolia-index="${hit.index}"
            data-algolia-position="${hit.productPosition}"
            data-algolia-queryid="${hit.queryID}"
            data-algolia-objectid="${hit.objectID}"
            href="${algoliaShopify.helpers.instantsearchLink(hit)}"
            onclick="void(0)"
            title="${algoliaShopify.helpers.fullTitle(
              hit.title,
              hit._distinct,
              hit.variant_title
            )}"
          >
            <div class="card__tags">
            ${hit && hit._highlightResult.tags ? 
                  hit._highlightResult.tags.some(tag => tag.value === "Online Out of Stock") ? 
                      (available_ = false,
                      html`<span class="card__tag card__tag--badge">${consult_tag_translation("Online Out of Stock")}</span>`) :
                      hit.named_tags && hit.named_tags.hasOwnProperty("Tag") ? 
                          (hit.named_tags["Tag"] == "FinalSale" || hit.named_tags["Tag"] == "PromoTag") ? 
                              html`<span class="card__tag card__tag--badge">${consult_tag_translation(hit.named_tags["Tag"])}</span>`: ''
                      : '' 
                  : ''
              }
              
            </div>
            <img
              class="ais-hit--picture"
              src="${algoliaShopify.helpers.originalImage(hit)}"
              alt="${hit.title} - ${hit.variant_title}"
            />
          </a>
          ${ hit.inventory_available == true && available_ ? html`<div class="card__quick-view">
              <button type="button" class="card__quick-view__btn" data-product-url="${window.Shopify.routes.root}products/${hit.handle}" onClick="${(event) => handleQuickViewClick(event, hit)}">${hit.inventory_available == true ? custom_ais_qv_translations.quick_view : window.custom_ais_qv_translations.sold_out}</button>
            </div>`: ``
          }
        </div>

        <div class="ais-hit--details">
          <p class="ais-hit--title">
            <aß

              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              onclick="void(0)"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              </a>
          </p>
          <p class="ais-hit--price">
            ${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.compare_at_price
                    )}</span
                  ></span
                >
              `}
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-discount"
                  >${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}</span
                >
              `}
          </p>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <div class="card__tags">
          ${hit && hit.named_tags && hit.named_tags.hasOwnProperty("Tag") ? 
            html`<span class="card__tag card__tag--ladeDelivery">${consult_tag_translation(hit.named_tags["Tag"])}</span>`
          : '' }
            
          </div>
          
          ${!hit._distinct &&
            html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart">
                ${hit.can_order
                  ? html`
                      <button
                        class="ais-hit--cart-button"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
                  : html`
                      <button
                        class="ais-hit--cart-button ais-hit--cart-button__disabled"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}
        </div>
      </div>
    `;
  });

  /* Search page sidebar filters */

  waitForElm('#aisSidebarFacets').then((elm) => {
    window.onclick = function(event) {
      if (event.target.closest("#aisSidebarFacets") != elm) {
        elm.closest("ais-filters-drawer").classList.remove("active");
      }
    }
  });

  waitForElm('#aisOpenSidebarFilters').then((elm) => {
    const filters = document.querySelector("ais-filters-drawer");
    elm.addEventListener("click", () => {
      setTimeout(()=>{filters.classList.add("active")},100)
      
    })
  });

  waitForElm('#aisFiltersClose').then((elm) => {
    elm.addEventListener("click", () => {
      elm.closest("ais-filters-drawer").classList.remove("active");
      
    })
  });

  function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  }

  /* End Search page sidebar filters */

  /* End Search Page widget */

  /* Autocomplete Widget */

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
          <div class="aa-PanelSection--left">
            ${displaySuggestions &&
              html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle"
                    >${algoliaShopify.translations.suggestions}</span
                  >
                  <div class="aa-SourceHeaderLine" />
                </div>
                ${elements.querySuggestionsPlugin}
              `}
            ${elements.collections} ${elements.articles} ${elements.pages}
            ${elements.redirectUrlPlugin}
          </div>
          <div class="aa-PanelSection--right">
            ${elements.products}
          </div>
        </div>
      </div>
    `;
  });


  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    const { html, state } = templateOptions;
    return html`
      <span class="aa-SourceHeaderTitle">
        ${algoliaShopify.translation_helpers.render_title(
          resource,
          state.query
        )}
      </span>
    `;
  });

  algoliaShopify.hooks.registerHook("beforeAutocompleteProductTemplate",function (_defaultTemplate, templateOptions, distinct, itemLink) {
    // Modify default options, then return them
    const { html, item, components } = templateOptions;
      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${(event) => handleItemClick(event, item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.compactImage(item)}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );

  algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <a
        class="aa-SeeAllBtn"
        href="${window.Shopify.routes.root}search?q=${state.query}"
      >
        <span>${algoliaShopify.translations.allProducts}</span>
        <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
        </path></svg>
      </a>
    `;
  });
  
  algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <p class="aa-NoResultsHeader">
          ${algoliaShopify.translation_helpers.no_result_for(state.query)}
        </p>
        <a class="aa-NoResultsLink" href="${window.Shopify.routes.root}search?q=">
          ${algoliaShopify.translations.allProducts}
          <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
          </path></svg>
        </a>
      </div>
    `;
  });

});